import { useEffect, useState } from 'react';
import { Lang } from '../api/lang';
import { getInitialLang, getStoredLang, setStoredLang } from '../api/langStorage';
import { changepassword } from '../api/api';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router';
import { getStoredRes } from '../api/resStorage';

const ChangePassword = () => {    
  const [lang, setLang] = useState<string>(() => getStoredLang());
    const [resolution, setResolution] = useState<string>(() => getStoredRes());
    const [isPortrait, setIsPortrait] = useState(false);
    const [bgopacity, setBgopacity] = useState<number>(1);
    const [titleopacity, setTitleopacity] = useState<number>(0);
    const [dialogopacity, setDialogopacity] = useState<number>(0);
    const [token, setToken] = useState(() => {
      try {
        const item: string = window.localStorage.getItem("token") as string;
        if (!item) return "";
        const decodedToken: any = jwtDecode(item);
        const currentTime = Date.now() / 1000; // Convert to seconds
        return (decodedToken.exp < currentTime) ? "" : item;
      } catch (error) {
        return "";
      }
    });
    const [password, setPassword] = useState<string>("");
    const [repassword, setRepassword] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [error, setError] = useState('');
    const [rotate,setRotate]=useState<number>(0);
    const history = useHistory();

    const handleSubmit = () => {
        // validate
         if (!password) {
            setLoading(false);
            setError("missing_password");
            return;
        }
        if (!repassword) {
            setLoading(false);
            setError("missing_repassword");
            return;
        }
        if (password!==repassword) {
            setLoading(false);
            setError("password_not_match");
            return;
        }
        if (password.length<6) {
            setLoading(false);
            setError("password_must_be_at_least_6_characters");
            return;
        }   
        setLoading(true);
        setError("");
        changepassword(password,repassword,token,lang).then((res:any)=>{
            setLoading(false);
            setIsSuccess(true);
        }).catch((err:any)=>{
            setLoading(false);
            if (err.response!==undefined && err.response.status===400) {
                setError(err.response.data.error);
            } else {
                setError("network_error");
            }
        });
    }

    const handleBack = () => {
        history.replace("/?lang="+lang+"&resolution="+resolution);
    }

    const handleLangChange = (value: string) => {
      setStoredLang(value);
      setLang(value);
    }

    useEffect(() => {
      document.title=Lang.get(lang,"lethal_blade_title");
    }, [lang]);

    const fadeInTitle=()=> {
      let opacity = 0;
      let bgopacity = 1;
      let dialogopacity = 0;
      const interval = setInterval(() => {
        opacity += 0.05; // เพิ่มทีละ 0.05
        setTitleopacity(opacity);
        bgopacity -= 0.03; // ลดทีละ 0.01
        setBgopacity(bgopacity);
        dialogopacity += 0.05; // เพิ่มทีละ 0.05
        setDialogopacity(dialogopacity);
        if (opacity >= 1) {
          clearInterval(interval); // หยุดเมื่อ opacity = 1
        }
      }, 130); 
    }

    useEffect(() => {
      document.body.style.backgroundColor="black";
      fadeInTitle();
      const mediaQuery = window.matchMedia("(orientation: portrait)");
      const handleOrientationChange = (e:any) => {
        setIsPortrait(e.matches);
      };
      setIsPortrait(mediaQuery.matches);
      mediaQuery.addEventListener("change", handleOrientationChange);

        const params = new URLSearchParams(window.location.search);
        setLang(getInitialLang(window.location.search));
      const t=(params.get('token') || '');
      if (t!=="") {
          setToken(t);
      }
      //ทำ animation หมุนรอ ช้าๆ
      const interval = setInterval(() => {
          setRotate((prevRotate) => (prevRotate + 0.1) % 360);
      }, 100);
      return () => {
      clearInterval(interval);
      mediaQuery.removeEventListener("change", handleOrientationChange);
    };
    }, []);

    return (<>
        <div className="c" style={{width:"100%",paddingRight:"10px",paddingTop:"10px",overflowX: "hidden",position: "absolute",zIndex: 9999}}>
          <table><tbody><tr>
          <td width="80%"></td>
          <td width="220px" style={{textAlign: "right",whiteSpace: "nowrap"}}>
            {Lang.get(lang,"bandwidth")}&nbsp;&nbsp;
          </td>
          <td width="80px">
          <select value={resolution} className="form-select form-select-sm form-control-sm" onChange={e=>{setResolution(e.currentTarget.value)}} style={{width:"70px"}}>
            <option value="low" >{Lang.get(lang,"low")}</option>
            <option value="high" >{Lang.get(lang,"high")}</option>
          </select>
          </td>
          <td width="80px">
          <select value={lang} className="form-select form-select-sm form-control-sm" onChange={e=>{handleLangChange(e.currentTarget.value)}} style={{width:"70px"}}>
            <option value="th">ไทย</option>
            <option value="en">Eng</option>
          </select>
          </td>
          </tr></tbody></table>
        </div>
          <div className="bg c" style={{justifyContent: "center", textAlign: "center",display:"block",opacity: bgopacity, backgroundImage: "url(lethalblade/assets/"+resolution+"/bg2.jpg)"}}>
          &nbsp;
        </div>
        <div className="c" style={{top:100,left: "50%",transform: "translate(-50%, 0)",marginLeft:"10px",width: "400px",position: "absolute",zIndex: 9999,display: "block",textAlign: "center",justifyContent: "center",opacity: dialogopacity}}>
          <img src={"lethalblade/assets/"+resolution+"/header.png"} alt="header" style={{width:"300px",height:"80px", transform: "scaleY(-1)"}}/><br/>
          { (isSuccess) &&
            <><span style={{width:"400px", whiteSpace: "normal"}}>{ Lang.get(lang,"reset_password_success")}</span><br/>
            <br/>
            <div className="buttonup"  style={{cursor: "pointer",position:"relative"}} onClick={handleBack}>
                <img src={"lethalblade/assets/"+resolution+"/buttonn.png"} alt="click"/>
                <div style={{position: "absolute",marginTop: "-5px",marginLeft:"-2px",top:"50%",left: "50%",transform: "translate(-50%, -50%)"}}>
                { Lang.get(lang,"back")}
                </div>
            </div>
            </> }
          { (!isSuccess) &&
            <> <span className="header">{ Lang.get(lang,"change_password")}</span><br/>
              <span style={{fontSize:"10pt"}}>{ Lang.get(lang,"please_enter_email")}</span><br/>
              <div style={{height:"10px"}}></div>
              <input className="inputnoborder" type="password" style={{width: "200px",height:"50px",backgroundColor: "rgba(0, 0, 0, 0.5)",borderRadius: "5px",borderColor:"#4ca0ab", color: "white" }} maxLength={200} value={password} onChange={e => setPassword(e.target.value)} placeholder={Lang.get(lang,"password")} disabled={loading}/><br/>
              <div style={{height:"10px"}}></div>
                <input className="inputnoborder" type="password" style={{width: "200px",height:"50px",backgroundColor: "rgba(0, 0, 0, 0.5)",borderRadius: "5px",borderColor:"#4ca0ab", color: "white" }} maxLength={200} value={repassword} onChange={e => setRepassword(e.target.value)} placeholder={Lang.get(lang,"repassword")} disabled={loading}/><br/>
                <div style={{height:"10px"}}></div>
                { error!=="" &&
                    <><span style={{color:"red"}}>{Lang.get(lang,error)}</span><br/></>
                }
                { loading &&
                <>
                  <img src={"lethalblade/assets/"+resolution+"/loading.png"} alt="loading" style={{width:"50px",height:"50px",transform: `rotateZ(${rotate}deg)`,zIndex: 9999}}/><br/>
                </>
                }
                { !loading && <>
                <div className="buttonup"  style={{cursor: "pointer",position:"relative"}} onClick={handleSubmit}>
                  <img src={"lethalblade/assets/"+resolution+"/buttonn.png"} alt="click"/>
                  <div style={{position: "absolute",marginTop: "-5px",marginLeft:"-2px",top:"50%",left: "50%",transform: "translate(-50%, -50%)"}}>
                    { Lang.get(lang,"ok_title")}
                  </div>
                </div>
                <div className="buttonup"  style={{cursor: "pointer",position:"relative"}} onClick={handleBack}>
                  <img src={"lethalblade/assets/"+resolution+"/buttonn.png"} alt="click"/>
                  <div style={{position: "absolute",marginTop: "-5px",marginLeft:"-2px",top:"50%",left: "50%",transform: "translate(-50%, -50%)"}}>
                    { Lang.get(lang,"cancel_title")}
                  </div>
                </div>
                </>}
            </>}
            <img src={"lethalblade/assets/"+resolution+"/header.png"} alt="header" style={{width:"300px",height:"80px",marginTop:"-20px"}}/>
            </div>
        <div className="c" style={{position: "absolute",left: "50%",transform: "translate(-50%, 0)",marginLeft:"0px",bottom:"0px",zIndex: 999,whiteSpace: "nowrap"}}>
          { Lang.get(lang,"copyright_title")} { Lang.get(lang,"all_right_reserve_title")}
        </div>
        </>);
}


export default ChangePassword;

